export enum OpportunitySubCategorySlug {
  RESTAURANTS_BARS = 'restaurants-bars',
  EDUCATION_CU = 'education-cu',
  EDUCATION_K_12 = 'education-k-12',
  HEALTHCARE_HOSPITALS = 'healthcare-hospitals',
}
